module.exports = __webpack_public_path__ + "static/ad-d42274826fceb5a1b786df1cfeb5a5ef.svg";